import MultiDropdown from './MultiDropdown';

export default MultiDropdown;
